import { createEvent, createStore, Event } from 'effector';
import { changeParams } from '../helpers/navigation';

interface IFiltersFabricConfig {
  listName: string;
  deaultValues?: Record<string, any>;
  resetEvent: Event<void>;
  syncWithQuery?: boolean;
}

const createFiltersStore = (config: IFiltersFabricConfig) => {
  const defaultFilters = { ...(config.deaultValues || null) };
  const { listName } = config;
  const setFilters: Event<Record<string, any>> = createEvent(`Set ${listName} filters`);
  const setFiltersHandler = (state: Record<string, any>, payload: Record<string, any>) => {
    const filters = { ...defaultFilters, ...payload };
    return filters;
  };
  const filters = createStore<Record<string, any>>(defaultFilters)
    .on(setFilters, setFiltersHandler)
    .reset(config.resetEvent);

  if (config.syncWithQuery) {
    setFilters.watch((filters) => {
      changeParams(filters);
    });
  }

  return { filters, setFilters };
};

export default createFiltersStore;
